import { render, staticRenderFns } from "./ReportSuccess.vue?vue&type=template&id=74cbd89e&scoped=true"
import script from "./ReportSuccess.vue?vue&type=script&lang=ts"
export * from "./ReportSuccess.vue?vue&type=script&lang=ts"
import style0 from "./ReportSuccess.vue?vue&type=style&index=0&id=74cbd89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cbd89e",
  null
  
)

export default component.exports